import { useState, useEffect } from "react";
import { useAuth } from "@/contexts/AuthContext";
import { supabase } from "@/integrations/supabase/client";

interface ActiveCoach {
  coachId: string;
  threadId: string | null;
  coachName: string | null;
}

export function useActiveCoach() {
  const { user } = useAuth();
  const [activeCoach, setActiveCoach] = useState<ActiveCoach | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!user) { setLoading(false); return; }

    const fetch = async () => {
      const { data: assignment } = await supabase
        .from("coach_client_assignments")
        .select("coach_id")
        .eq("client_id", user.id)
        .eq("status", "active")
        .limit(1)
        .maybeSingle();

      if (!assignment) { setActiveCoach(null); setLoading(false); return; }

      const [{ data: profile }, { data: thread }] = await Promise.all([
        supabase.from("profiles").select("display_name, first_name").eq("user_id", assignment.coach_id).maybeSingle(),
        supabase.from("message_threads").select("id").eq("coach_id", assignment.coach_id).eq("client_id", user.id).maybeSingle(),
      ]);

      setActiveCoach({
        coachId: assignment.coach_id,
        threadId: thread?.id || null,
        coachName: profile?.display_name || profile?.first_name || "Coach",
      });
      setLoading(false);
    };
    fetch();
  }, [user]);

  return { activeCoach, loading };
}
